import type { RichTextLinkPolicy } from '@/shared/components';

const ALLOWED_LINK_URI = /^(https:\/\/|mailto:)/i;

export const isAllowedLinkUri = (url: string): boolean => ALLOWED_LINK_URI.test(url) && !url.includes('{{');

export const TEMPLATE_LINK_POLICY: RichTextLinkPolicy = {
  isAllowed: isAllowedLinkUri,
  message: 'Enter an https:// or mailto: address without variables',
};
